import { t } from '@web/i18n';
import { Card, formatRawDate } from '@web/ui/core';
import type { MiceProjectFormState } from '../hooks/use_mice_project_form';

function Row({ label, value }: Readonly<{ label: string; value: string | null | undefined }>) {
  return (
    <div className="flex justify-between gap-3 border-b border-border-soft py-1.5 text-meta last:border-b-0">
      <span className="text-muted-foreground">{label}</span>
      <span className="truncate text-right text-foreground">{value || '—'}</span>
    </div>
  );
}

/** O que já foi decidido no cadastro, e o que vem depois de criar o evento. */
export function NewEventSummary({ form }: Readonly<{ form: MiceProjectFormState }>) {
  const period =
    form.eventStart && form.eventEnd && !form.rangeInvalid
      ? t('mice.project.period', {
          start: formatRawDate(form.eventStart, null),
          end: formatRawDate(form.eventEnd, null),
        })
      : null;
  return (
    <aside className="flex w-full flex-col gap-3 sm:w-80">
      <Card>
        <div className="flex flex-col p-4">
          <span className="font-mono text-tiny uppercase tracking-eyebrow-wide text-faint-foreground">
            {t('mice.form.summary')}
          </span>
          <span className="mb-2 mt-1 font-serif text-base font-semibold text-foreground">
            {form.name.trim() || '—'}
          </span>
          <Row label={t('mice.form.summaryPeriod')} value={period} />
          <Row label={t('mice.form.client')} value={form.client?.name} />
          <Row label={t('mice.form.debitCompany')} value={form.debitCompany?.name} />
          <Row
            label={t('mice.form.requester')}
            value={form.requester?.name || form.requester?.email}
          />
        </div>
      </Card>
      <Card>
        <div className="flex flex-col gap-2 p-4 text-meta text-foreground-default">
          <span className="font-mono text-tiny uppercase tracking-eyebrow-wide text-faint-foreground">
            {t('mice.form.summaryNext')}
          </span>
          <p>{t('mice.form.next1')}</p>
          <p>{t('mice.form.next2')}</p>
        </div>
      </Card>
    </aside>
  );
}
